export default __webpack_public_path__ + "static/media/FuturaLightBt.ead7282f.ttf";